import { ROLES_AND_PERMISSIONS_POPUP } from "@elixir/types";
import { create } from "zustand";
import { TAccessControlStore } from "./types";

const useAccessControlStore = create<TAccessControlStore>((set, get) => ({
  setEditRole: (editRole) => set({ editRole }),

  setEditUser: (editUser) => set({ editUser }),

  rolesAndPermissionsPopup: ROLES_AND_PERMISSIONS_POPUP.NONE,
  setRolesAndPermissionsPopup: (rolesAndPermissionsPopup) =>
    set({ rolesAndPermissionsPopup }),
}));

export default useAccessControlStore;
